import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MessageRequest, SkyproMessagesModule } from '@skyeng/libs/skypro/messages';
import { DsDialogInstance, DsDialogModule } from '@skyeng/libs/shared/ui-kit-v2/dialog';
import { provideTranslationStatic } from '@skyeng/libs/shared/i18n';
import { DecorateUntilDestroy, takeUntilDestroyed } from '@skyeng/libs/shared/rxjs';
import { tap } from 'rxjs/operators';
import { ReportDialogInput } from '../../interface';
import { CommunicationService } from '../../service/communication.service';
import { TranslocoModule } from '@ngneat/transloco';
import { TypografModule } from '@skyeng/libs/skypro/misc';
import rutranslation from './translation/ru.json';

enum ValidationErrors {
  error = 'error',
  blankError = 'blankError',
}

@DecorateUntilDestroy()
@Component({
  selector: 'skypro-communication-report-dialog',
  templateUrl: 'communication-report-dialog.html',
  styleUrls: ['communication-report-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslationStatic('skyproCommunicationReportDialog', { ru: rutranslation })],
  imports: [DsDialogModule, SkyproMessagesModule, TranslocoModule, TypografModule],
})
export class CommunicationReportDialogComponent {
  isSending = false;
  validationError: ValidationErrors | null = null;

  private dsDialogInstance = inject(DsDialogInstance<{ message: MessageRequest }, ReportDialogInput>);
  private communicationLikeService = inject(CommunicationService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  sendReport(message: MessageRequest | undefined): void {
    if (!message) {
      return;
    }

    const getTextFromHtml = (html: string): string => {
      return new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
    };

    this.validationError = null;
    if (getTextFromHtml(message.text).replace(/\s/g, '') === '') {
      this.validationError = ValidationErrors.blankError;
      return;
    }

    this.isSending = true;

    this.communicationLikeService
      .sendReport(this.dsDialogInstance.data.contentId, message.text)
      .pipe(
        tap({
          next: () => {
            this.isSending = false;
            this.dsDialogInstance.close({ rejected: false });
          },
          error: () => {
            this.isSending = false;
            this.validationError = ValidationErrors.error;
            this.changeDetectorRef.detectChanges();
          },
        }),
        takeUntilDestroyed(this),
      )
      .subscribe();
  }
}
